import { editTaskDate } from '@/services/task/task'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { memo, useEffect, useState } from 'react'
import styles from './index.module.less'

export default memo(function TaskDate(props: any) {
  const { task, field, editable = true, onSuccess } = props
  const [editing, setEditing] = useState(props.editing || false)
  const [value, setValue] = useState<any>()

  useEffect(() => {
    setValue(task[field])
  }, [task])

  const handleChange = async (value) => {
    if (value) {
      const data = await editTaskDate(task.id, { [field]: value })
      onSuccess?.(data)
      setEditing(false)
      setValue(value)
    } else {
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <DatePicker
        autoFocus
        value={value ? dayjs(value) : null}
        onChange={(dayjsValue) => {
          const value = dayjsValue?.valueOf()
          handleChange(value)
        }}
        onBlur={() => {
          setEditing(false)
        }}
        open={true}
      />
    )
  }

  return (
    <div
      className={styles.fieldItem}
      onClick={() => {
        if (editable) {
          setEditing(true)
        }
      }}
    >
      {value && dayjs(value).format('YYYY-MM-DD')}
    </div>
  )
})
